const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작업일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['작업일', '인원투입현황', '장비투입현황']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'header.date', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'header.date', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "작업일",
        "key": "header.date",
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "인원투입현황",
        "key": "body.인원투입현황"
      },
      {
        "name": "장비투입현황",
        "key": "body.장비투입현황"
      }
    ]
  },
  getCol: (index, value, func) => {
    const postContent = JSON.parse(value.post_content);
    try {
      switch (index) {
        case 0: return postContent.header.date // 작업일
        case 1: return func.getContent(value).stdInfo.field_name // 사업장명
        case 2: return func.getContent(value).인원투입현황? func.getContent(value).인원투입현황.length:0 // 인원투입현황
        case 3: return func.getContent(value).장비투입현황? func.getContent(value).장비투입현황.length:0 // 장비투입현황
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
